export const FETCH_NATIONALITIES = 'FETCH_NATIONALITIES';

export const BUYER_LIST_OPERATION_START = 'BUYER_LIST_OPERATION_START';
export const BUYER_LIST_OPERATION_END = 'BUYER_LIST_OPERATION_END';
export const FETCH_BUYER_LIST = 'FETCH_BUYER_LIST';

export const ON_PROCEED_VALIDATION_START = 'ON_PROCEED_VALIDATION_START';
export const ON_PROCEED_VALIDATION = 'ON_PROCEED_VALIDATION';
export const ON_PROCEED_VALIDATION_END = 'ON_PROCEED_VALIDATION_END';

export const CLOSE_BUYER_MODAL = 'CLOSE_BUYER_MODAL';

export const UPLOAD_BUYER_DOCUMENT_START = 'UPLOAD_BUYER_DOCUMENT_START';
export const UPLOAD_BUYER_DOCUMENT = 'UPLOAD_BUYER_DOCUMENT';
export const UPLOAD_BUYER_DOCUMENT_ERROR = 'UPLOAD_BUYER_DOCUMENT_ERROR';

export const ADD_BUYER_SUCCESS = 'ADD_BUYER_SUCCESS';
